import Vue from 'vue'
import Router from 'vue-router'


//登录
import login from '@/pages/login/index'

//离职HR
import leave from '@/pages/leavePerson/leave'

//找回密码
import forgot from '@/pages/forgot/index'

//注册
import register from '@/pages/register/index'

//跳转老板本中转页面
import transit from '@/pages/login/transit'

//智能邀约介绍
import talentIntroduce from '@/pages/unloginIntroduce/talentIntroduce'
//简历库更新介绍
import updateIntroduce from '@/pages/unloginIntroduce/updateIntroduce'
//供应商管理介绍
import vmsIntroduce from '@/pages/unloginIntroduce/vmsIntroduce'

Vue.use(Router)



export default new Router({
  routes: [{
      path: '/',
      name: 'login',
      meta: {
        title: '登录 - 猎上网'
      },
      component: login
    },
    {
      path: '/leave',
      name: 'leave',
      meta: {
        title: '离职 - 猎上网'
      },
      component: leave
    },
    {
      path: '/forgot',
      name: 'forgot',
      meta: {
        title: '找回密码 - 猎上网'
      },
      component: forgot
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        title: '注册 - 猎上网'
      },
      component: register
    }, {
      path: '/transit',
      name: 'transit',
      meta: {
        title: '猎上网'
      },
      component: transit
    }, {
      path: '/talentIntroduce',
      name: 'talentIntroduce',
      meta: {
        title: '智能简历 - 猎上网'
      },
      component: talentIntroduce
    }, {
      path: '/updateIntroduce',
      name: 'updateIntroduce',
      meta: {
        title: '简历库更新 - 猎上网'
      },
      component: updateIntroduce
    }, {
      path: '/vmsIntroduce',
      name: 'vmsIntroduce',
      meta: {
        title: '供应商管理 - 猎上网'
      },
      component: vmsIntroduce
    }
  ]
})



// WEBPACK FOOTER //
// ./src/modules/login/router.js